import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants.js';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const SpentThisMonth = ({ amount = '£291.30' }) => {
  const { translateText } = useTranslation();

  return (
    <div className={styles.statCard} data-testid="walletSpentThisMonth">
      <div className={styles.statHeader}>
        <span className={styles.statLabel}>
          {translateText('corporateAccounts.wallet.dashboard.spentThisMonth.label')}
        </span>
      </div>
      <div className={`${styles.statValue} ${styles.statValueSmall}`}>{amount}</div>
      <div className={`${styles.statSub} ${styles.statSubTight}`}>
        <Link
          to={ROUTES.REPORTS}
          className={styles.link}
          data-testid="walletSpentThisMonthReportsLink"
        >
          {translateText('corporateAccounts.wallet.dashboard.spentThisMonth.link')}
        </Link>
      </div>
    </div>
  );
};

export default SpentThisMonth;
